import * as yup from "yup";

import {
  FieldRequestFieldEnum,
  FieldRequestTypeEnum,
} from "@/features/common/enums";
import type { IFieldRequestInput } from "@/features/lender-responses/types/lender-response";

export const bidFieldRequestSchema: yup.ObjectSchema<IFieldRequestInput> = yup
  .object()
  .shape({
    field: yup
      .mixed<FieldRequestFieldEnum>()
      .oneOf(Object.values(FieldRequestFieldEnum))
      .required(),
    lenderComment: yup.string().nullable(),
    isCollectedByLender: yup.boolean().default(false),
    type: yup
      .mixed<FieldRequestTypeEnum>()
      .oneOf(Object.values(FieldRequestTypeEnum))
      .required(),
    config: yup
      .object()
      .nullable()
      .shape({
        numberOfRequiredGuarantors: yup
          .number()
          .required("Number of guarantors is required")
          .min(1, (schema) => `Can't be fewer than ${schema.min}`)
          .max(10, (schema) => `Can't be more than ${schema.max}`),
        reducedGuarantorPercentTo: yup
          .number()
          .nullable()
          .min(1, (schema) => `Can't be less than ${schema.min}`)
          .max(99, (schema) => `Can't be more than ${schema.max}`),
      })
      .when("checked", {
        is: true,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
  });
